import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { BikeleasingBenefitListItemExtension } from './bikeleasing-benefit-list-item.extension';
import { BikeleasingBenefitMetadataExtension } from './bikeleasing-benefit-metadata.extension';
import { BikeleasingRoutesExtension } from './bikeleasing-routes.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bikeleasing')
    .add(BenefitMetadataExtensionInterface, new BikeleasingBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new BikeleasingBenefitListItemExtension())
    .add(RoutesExtensionInterface, new BikeleasingRoutesExtension())
    .build(),
);
